import { Decryption, Encryption } from "./Function";

export const setLocal = (key, value) =>
  localStorage.setItem(key, Encryption(value));

export const removeLocal = (key) => localStorage.removeItem(key);

export const getLocal = (key) => Decryption(localStorage.getItem(key));
